enum LoginStep: EnterEmail, EnterPasswordForExistingUser, RegisterNewUser, ChangePassword

Page loginPage
	title = "Anmelden oder Registrieren"
	needsAuth = false
	
	LoginStep	step	= EnterEmail
	bool	isLoading	= false
	ValidationState	validationState	= {}
	string	resetToken	= ""
	bool	resetEmailSent	= false
	string	email = ""
	string	password = ""
	string	passwordConfirm = ""

	show: string id = ""
		html.setTitle title + app.titleSuffix
		validationState.clear
		resetEmailSent = false
		if id and id.startsWith("change-password/")
			resetToken = id.substring(16)
			step = ChangePassword
		else if not app.user and editPage.good?.EMail
			email = editPage.good.EMail
			await onEmailEntered
		else
			email = Platform.getLocalStorageString("lastEmail")
			step = EnterEmail

	private async checkEmailExists: string emailToCheck
		try
			let record = await backend.users.fetchOne "email='{emailToCheck}'", fields:"email"
			return record != null
		catch as error
			return false

	draw
		div display:flex, flexDirection:column, alignItems:center, padding:{top:60 bottom:60}
			switch step
				EnterEmail: drawEnterEmail
				EnterPasswordForExistingUser: drawEnterPasswordForExistingUser
				RegisterNewUser: drawSignupNewUser
				ChangePassword: drawChangePassword

	drawEnterEmail
		app.box width:460px
			div width:100%, display:flex, flexDirection:column, alignItems:center
				div tag:"h1", text:"Anmelden oder Registrieren", fontSize:30, fontWeight:bold, color:#2b3145, margin:{bottom:8}
				div text:"Es dauert nur 30 Sekunden.", fontSize:16, color:#7a8195, margin:{bottom:32}
				
				div width:100%, display:flex, flexDirection:column, gap:24
					form.email label:"E-Mail", model:email, width:100%, required:true, validationState, focusInitially:true, autocomplete:"username"
					app.button text:"Weiter", isDisabled:isLoading, triggerWithEnterKey:true
						onClick:
							if validationState.checkForErrorsOrEmptyFields then return
							isLoading = true
							refresh
							onEmailEntered

	onEmailEntered
		Platform.setLocalStorageString("lastEmail", email)
		if await checkEmailExists(email) then	step = EnterPasswordForExistingUser
		else	step = RegisterNewUser
		validationState.clear
		isLoading = false
		refresh

	setSellerAndNavigateToEditPage
		await app.goods.update editPage.good, {seller:app.user.id, state:GoodState.Draft}
		app.navigateTo editPage, editPage.good.id

	drawEnterPasswordForExistingUser
		app.box width:460px
			div width:100%, display:flex, flexDirection:column, gap:16, alignItems:stretch
				div tag:"h1", text:"Anmelden", fontSize:32, fontWeight:bold, color:#2b3145, margin:{bottom:8}
				
				div width:100%, display:flex, flexDirection:column, gap:24
					div display:flex, flexDirection:column, gap:8
						div text:"E-Mail", fontSize:14, color:#40465a, fontWeight:500
						input value:email, readOnly:true, fontSize:16, color:#7a8195, padding:{12 16}, backgroundColor:#f9fafb, borderRadius:8, border:none, width:100%, data:{type:"email", autocomplete:"username", name:"email"}
					
					form.password label:"Passwort", model:password, width:100%, required:true, validationState, focusInitially:true
					
					if resetEmailSent
						div text:"E-Mail versendet! Bitte prüfen Sie Ihr Postfach.", fontSize:14, color:style.okColor, textAlign:center
					else
						div text:"Ich habe mein Passwort vergessen", textDecoration:underline, fontSize:14, textAlign:center, color:style.primaryColor, cursor:pointer
							onClick:
								isLoading = true
								refresh
								try
									await backend.pb.collection('users').requestPasswordReset(email)
									resetEmailSent = true
								catch as error
									print type:Error "Error resetting password", error
								isLoading = false
								refresh
					
					app.button text:"Anmelden", isDisabled:isLoading, triggerWithEnterKey:true
						onClick:
							if validationState.checkForErrorsOrEmptyFields then return
							isLoading = true
							refresh

							try
								app.user = await backend.authWithPassword(email, password)
								isLoading = false
								validationState.clear
								app.onLogin
								if editPage.good?.state == Guest
									setSellerAndNavigateToEditPage
								else								
									app.navigateTo homePage
							catch as error
								isLoading = false
								validationState.overrideError(label:"Passwort", message:"Das Passwort ist nicht korrekt. Bitte prüfen Sie Ihre Eingabe.")
								refresh

	drawSignupNewUser
		app.box width:460px
			div width:100%, display:flex, flexDirection:column, gap:16, alignItems:stretch
				div tag:"h1", text:"Wählen Sie ein Passwort", fontSize:32, fontWeight:bold, color:#2b3145, margin:{bottom:8}
				
				div display:flex, flexDirection:column
					div text:"E-Mail", fontSize:14, color:#40465a, fontWeight:500
					input value:email, readOnly:true, fontSize:16, color:#7a8195, padding:{12 16}, backgroundColor:#f9fafb, borderRadius:8, border:none, width:100%, data:{type:"email", autocomplete:"username", name:"email"}
				column
					div text:"Bitte prüfen Sie, ob Ihre E-Mail-Adresse korrekt ist.", fontSize:14, textAlign:center
					div text:"E-Mail-Addresse korrigieren", textDecoration:underline, fontSize:14, textAlign:center, color:primaryColor, cursor:pointer, onClick:step = EnterEmail; validationState.clear; refresh
				form.password label:"Passwort", model:password, width:100%, required:true, minTextLength:8, maxTextLength:100, validationState, focusInitially:true
				form.password label:"Passwort bestätigen", model:passwordConfirm, width:100%, required:true, minTextLength:8, maxTextLength:100, validationState, matchModel:password
				app.button text:"Kostenfrei registrieren", isDisabled:isLoading, triggerWithEnterKey:true
					onClick:
						if validationState.checkForErrorsOrEmptyFields then return
						isLoading = true
						refresh
						
						try
							// Change email (from the randomly generated guest email to email) and password
							// Uses custom backend endpoint that bypasses email verification for guest users
							
							app.user = {email: email, password:password, passwordConfirm:password}
							if editPage.good	then app.user.phoneNumber = editPage.good.Telefon
							if homePage.generalTermsAccepted	then app.user.generalTermsAccepted = homePage.generalTermsAccepted
							await backend.signupNewUser app.user
							await backend.requestVerification(email)
							Platform.setLocalStorageString("lastEmail", email)
							isLoading = false
							validationState.clear
							app.onLogin
							if editPage.good?.state == Guest
								setSellerAndNavigateToEditPage
							else
								app.navigateTo accountPage
						catch as error
							isLoading = false
							print type:Error "Error registering new user:", error
							refresh

	drawChangePassword
		app.box width:600px
			div width:100%, display:flex, flexDirection:column, gap:32, alignItems:center
				div tag:"h1", text:"Wählen Sie ein neues Passwort", fontSize:32, fontWeight:bold, color:#2b3145
				
				div width:100%, display:flex, flexDirection:column, gap:24
					form.password label:"Neues Passwort", model:password, width:100%, required:true, minTextLength:8, maxTextLength:100, validationState, focusInitially:true
					form.password label:"Passwort bestätigen", model:passwordConfirm, width:100%, required:true, minTextLength:8, maxTextLength:100, validationState, matchModel:password
					app.button text:"Passwort ändern", isDisabled:isLoading, triggerWithEnterKey:true
						onClick:
							if validationState.checkForErrorsOrEmptyFields then return
							isLoading = true
							refresh
							
							try
								await backend.pb.collection('users').confirmPasswordReset(resetToken, password, passwordConfirm)
								isLoading = false
								validationState.clear
								password = ""
								passwordConfirm = ""
								step = EnterEmail
								alert "Passwort erfolgreich geändert! Bitte melden Sie sich mit Ihrem neuen Passwort an."
								refresh
							catch as error
								isLoading = false
								print type:Error "Error confirming password reset:", error
								validationState.overrideError(label:"Neues Passwort", message:"Fehler beim Ändern des Passworts. Der Link ist möglicherweise abgelaufen.")
								refresh
